import { FC } from "react";
import { CommonIconProps } from "../Icon/types";

const Comparison: FC<CommonIconProps> = ({
  stroke = "var(--icon-fill-color, var(--color-primary))"
}) => {
  return (
    <svg
      className="icon-comparison"
      width="100%"
      height="100%"
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.5 10V10C4.567 10 3 8.433 3 6.5V6.5C3 4.567 4.567 3 6.5 3V3C8.433 3 10 4.567 10 6.5V6.5C10 8.433 8.433 10 6.5 10Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 21H16C15.448 21 15 20.552 15 20V16C15 15.448 15.448 15 16 15H20C20.552 15 21 15.448 21 16V20C21 20.552 20.552 21 20 21Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 6.5H10"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 3.5L21 6.5L18 9.5"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 18H15"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 21L3 18L6 15"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Comparison;
